export default {}

export const pageTitle = 'KAKA ELECTRIC AND MACHINERY STORE'
export const subTitle = ''
// export const apiUrl = `http://localhost:9292`
export const apiUrl = `https://api.gsthisaab.in`

export const verifyGstKey = 'yi6MGg3H4Pem0lO2OeLphLm9OIl2'
